module.exports = __webpack_public_path__ + "img/Comic_23.fe6cb018.png";